import ComponentBasePrototype from 'ComponentBasePrototype';

export default class CustomCode extends ComponentBasePrototype {
  build() {
    this.node.find('script').html(this.data.script);
  }
}
